(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const nameInput = document.querySelector('.school-name-input');
  const name = localStorage.getItem('schoolName') || '';
  const walletBtns = document.querySelector('.dynamic-checkout');

  if (name.length > 2) {
    nameInput.value = name;
  }

  if (nameInput.value.trim().length > 2) {
    walletBtns.style.visibility = 'visible';
    walletBtns.style.opacity = 1;
  } else {
    walletBtns.style.visibility = 'hidden';
    walletBtns.style.opacity = 0;
  }

  nameInput.addEventListener('keyup', ev => {
    localStorage.setItem('schoolName', ev.target.value);

    if (ev.target.value.trim().length > 2) {
      walletBtns.style.visibility = 'visible';
      walletBtns.style.opacity = 1;
    } else {
      walletBtns.style.visibility = 'hidden';
      walletBtns.style.opacity = 0;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    let nameInput = document.querySelector('#SchoolName-Note');
  let cartOpen = document.querySelector('#cart-icon-bubble');
  let cartDrawer = document.querySelector('cart-drawer');
  const addToCart = document.querySelector('#ProductSubmitButton-template--21961149022425__main');
  const drawerCheckout = document.querySelector('#CartDrawer-Checkout');

  function checkStorage() {
    nameInput = document.querySelector('#SchoolName-Note');
    const name = localStorage.getItem('schoolName') || '';
    if (name.length > 2) {
      nameInput.value = name;
      setTimeout(()=> {
        nameInput = document.querySelector('#SchoolName-Note');
        nameInput.value = name;
      }, 500)
    } else {
      nameInput.value = '';
    }
  }

  drawerCheckout.addEventListener('click', checkStorage);
  nameInput.addEventListener('focus', () => {
    checkStorage();
  });

  if (cartDrawer) {
    let hadActive = cartDrawer.classList.contains('active');
    const observer = new MutationObserver(() => {
      const hasActive = cartDrawer.classList.contains('active');

      if (!hadActive && hasActive) {
        nameInput = document.querySelector('#SchoolName-Note');
        cartOpen = document.querySelector('#cart-icon-bubble');
        cartDrawer = document.querySelector('cart-drawer');
        checkStorage();
      }

      hadActive = hasActive;
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function observeCartDrawer() {
    const targetNode = document.body;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const found = node.querySelector?.("#SchoolName-Note");
          if (found) {
            checkStorage();
          }
        }
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });

    return observer;
  }
  observeCartDrawer();

  cartOpen.addEventListener('click', checkStorage);
  addToCart.addEventListener('click', checkStorage);
  } catch(e) { console.error(e); }
})();

})();
